<template>
  <div id="app" class="noselect">
    <router-view />
  </div>
</template>

<script>
import BranchRouter from "@/views/Login/BranchRouter.json"
import CommitteeRouter from "@/views/Login/CommitteeRouter.json"
import { getVersionapi } from './network/api/login';
import OrganizationDepartmentRouter from "./views/Login/OrganizationDepartmentRouter.json";
export default {
  name: "App",
  data() {
    return {
      identity: ""
    }
  },
  methods: {
    getBrowser(){
      //判断是否IE浏览器
      const userAgent = navigator.userAgent
      if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        this.$confirm('您当前使用的是IE内核浏览器,将会导致您不能获得最佳软件使用体验，点击确定前往更新为webkit内核浏览器', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.RouteGo("http://chrome.haochuang66.cn/")
        }).catch((e) => {
          //
        });
      };
    },
    async GetIdentity() {
      if (this.$route.fullPath === "/") {
        return false
      }
      const data = await this.PublicApi("admin/organization/getId")
      // 管理人员身份认证获取
      this.$setSession("ISCOM", data.data.is_com)
         // 设置组织等级
      this.$setSession("OCATEGRORYID", data.data.o_category_id)
        //设置是否是领头羊
        this.$setSession("is_top_public", data.data.is_top_public)
      this.$store.state.Identity = data.data.is_com === 1 ? "党组织" : "支部"
      this.$store.state.IdentityLevel = data.data.is_com === 1 ? "委员" : "党员"
      this.$store.state.IsBranch = data.data.is_com === 1 ? false : true
      const ISCOM = data.data.is_com
      if (ISCOM === 1) {
        // 1是党委 0是支部
        // console.log("党委", ISCOM)
        if(data.data.o_category_id == 4){
          this.$store.state.HCRoutes = OrganizationDepartmentRouter
          this.$setSession("HCroutes", JSON.stringify(OrganizationDepartmentRouter))
        } else {
          this.$store.state.HCRoutes = CommitteeRouter
          this.$setSession("HCroutes", JSON.stringify(CommitteeRouter))
        }
      } else {
        // console.log("支部", ISCOM)
        this.$store.state.HCRoutes = BranchRouter
        this.$setSession("HCroutes", JSON.stringify(BranchRouter))
      }
    },
  },
  created() {
    this.getBrowser()
    this.GetIdentity();
    // 读取sessionStorage信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      )
    }
    // 页面刷新时将vuex保存到sessionStorage
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
    //检测更新
    this.$store.dispatch("autoupdateapp"); //检测更新
  },
};
</script>

<style>
@import url("./assets/css/global.css");
@import url("./assets/css/icon.css");
</style>



// WEBPACK FOOTER //
// src/App.vue